import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default function parseOffset(offset, width, height) {
  var _offset$split = offset.split(' '),
      _offset$split2 = _slicedToArray(_offset$split, 2),
      offsetX = _offset$split2[0],
      offsetY = _offset$split2[1];

  var parsedOffsetX = offsetX.indexOf('%') !== -1 ? parseFloat(offsetX) / (100 * width) : parseFloat(offsetX);
  var parsedOffsetY = offsetY.indexOf('%') !== -1 ? parseFloat(offsetY) / (100 * height) : parseFloat(offsetY);
  return [parsedOffsetX, parsedOffsetY];
}